import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getraceresultSlice = createSlice({
    name: 'raceresult',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchraceresult.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchraceresult.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        })
        .addCase(fetchraceresult.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setraceresult , setStatus} = getraceresultSlice.actions;
export default getraceresultSlice.reducer;

export const fetchraceresult = createAsyncThunk('/raceresultget/fetch', async({currentPage,racenameid,startdate1,enddate1}) => {
    const res = await axios.get(`${window.env.API_URL}/AllDeclaredRaces?page=${currentPage}&RaceName=${racenameid === undefined ? '' : racenameid}&racestartday=${startdate1 == undefined ? '' : startdate1} &raceendday=${enddate1 == undefined ? '' : enddate1}`);
    const raceresultData = res.data;
    return raceresultData;
})